import { useState, useContext, useMemo } from 'react';
import { Row, Col } from 'react-bootstrap';
import BaffleText from '../../components/baffle-text';
import AnimationContainer from '../../components/animation-container';
import ThemeContext from '../../context';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub,
  faLinkedin,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';

import Ivana from '../../assets/img/team/ivana.jpg';

import heinekenUrl from '../../assets/img/clients/heineken.svg';
import kpmgUrl from '../../assets/img/clients/KPMG.svg';
import lloydsUrl from '../../assets/img/clients/lloyds.svg';
import vertexUrl from '../../assets/img/clients/Vertex.svg';
import wppUrl from '../../assets/img/clients/WPP.svg';
import brcUrl from '../../assets/img/clients/brc.svg';

const Team = ({ id }) => {
  const [show, setShow] = useState(false);
  const context = useContext(ThemeContext);

  const items = useMemo(
    () => [
      { name: heinekenUrl },
      { name: kpmgUrl },
      { name: lloydsUrl },
      { name: vertexUrl },
      { name: wppUrl },
      { name: brcUrl },
    ],
    []
  );

  const showFunc = () => setShow(true);

  const clients = () => {
    if (show || context.height === 'auto') {
      return items.map((value) => (
        <Col md={2} className='client' key={value.name}>
          <AnimationContainer delay={100} animation='fadeIn slow'>
            <img
              src={value.name}
              alt='client'
              loading='lazy'
              decoding='async'
              style={{ width: '100%' }}
            />
          </AnimationContainer>
        </Col>
      ));
    }

    return null;
  };

  const teamMembers = () => (
    <AnimationContainer delay={200} animation='fadeIn slow'>
      <div className='team-profile'>
        <div className='team-member'>
          <div className='team-member-content'>
            <img
              src={Ivana}
              alt='Ivana Pantazi'
              loading='lazy'
              decoding='async'
            />

            <div className='social social_icons'>
              <FontAwesomeIcon
                icon={faFacebook}
                className='social_icon'
                onClick={() =>
                  window.open('https://www.facebook.com/ivpweb', '_blank')
                }
              />

              <FontAwesomeIcon
                icon={faGithub}
                className='social_icon'
                onClick={() =>
                  window.open('https://github.com/ivanapantazi', '_blank')
                }
              />

              <FontAwesomeIcon
                icon={faLinkedin}
                className='social_icon'
                onClick={() =>
                  window.open('https://www.linkedin.com/in/ivanap/', '_blank')
                }
              />
            </div>
          </div>
        </div>

        <div className='team-intro'>
          <h3>Ivana Pantazi</h3>

          <h4>Founder & Lead Front-End Developer</h4>

          <p>
            I'm a Front-End Developer and founder of IvP Web OÜ, passionate
            about creating modern, accessible and user-friendly digital
            experiences. Over the years I've worked with organisations ranging
            from start-ups to global brands, delivering websites, applications
            and digital products that combine strong technical foundations with
            thoughtful design.
          </p>

          <p>
            My expertise includes React, JavaScript, responsive web development,
            accessibility, performance optimisation and user experience. I enjoy
            helping businesses transform ideas into reliable digital solutions
            that are fast, scalable and easy to maintain.
          </p>
        </div>
      </div>
    </AnimationContainer>
  );

  return (
    <section
      id={id}
      className='team'
      style={{ height: context.height }}
      tabIndex='0'
    >
      <Row>
        <div className='content'>
          <div className='line-text'>
            <h4>Who we are</h4>
          </div>

          <div className='heading'>
            <BaffleText
              text='Meet the founder'
              revealDuration={500}
              revealDelay={500}
              parentMethod={showFunc}
              callMethodTime={1100}
            />
          </div>

          <div className='team-container'>{teamMembers()}</div>
        </div>
      </Row>

      <Row className='bottom'>{clients()}</Row>
    </section>
  );
};

export default Team;
